import { RequestBuilder } from '../request_builder'

export class ExchangeRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'exchange'
  }

  order (from, to) {
    this.filters.push('order')
    this.setParams({from: from, to: to})
    return this
  }

  convert (amount, sourceAsset, destAsset) {
    this.filters.push('convert')
    this.addQuery('amount', amount)
    this.addQuery('source_asset', sourceAsset)
    this.addQuery('dest_asset', destAsset)
    return this
  }

  forCode (source, precision) {
    this.filters.push(source)
    if (precision !== undefined) {
      this.addQuery('precision', precision)
    }
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/exchange_request_builder.js